import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import LinearProgress from '@material-ui/core/LinearProgress';
import styles from './listLoader.module.scss';

export default memo(function ListLoader(props) {
    const [t] = useTranslation(props.dictionary);

    return (
        <div className={styles.container}>
            {props.showProgress && <LinearProgress />}
            <div className={styles.detail}>
                <span>{t(`${props.dictionary}:${props.text}`)}</span>
            </div>
        </div>
    );
}, (prevProps, nextProps) =>
        prevProps.dictionary === nextProps.dictionary &&
        prevProps.text === nextProps.text &&
        prevProps.showProgress === nextProps.showProgress
);
